import apiClient from './axios';
import { ApiResponse } from '../types';

export type ContentPageKey =
  | 'shop_faqs'
  | 'referral_faqs'
  | 'shop_terms'
  | 'returns_refund_policy'
  | 'general_terms'
  | 'privacy_policy'
  | 'legal'
  // PayIQ's escrow terms, shown on every business storefront. Ours to write
  // because it describes what PayIQ does with a buyer's money — a seller
  // cannot define it and should not be able to.
  | 'escrow_policy';

export type ContentPageType = 'faq' | 'sections';

export interface ContentPageSection {
  id: string;
  title?: string;
  description?: string;
  question?: string;
  answer?: string;
  sortOrder?: number;
}

export interface ContentPage {
  id: string;
  key: ContentPageKey;
  title: string;
  contentType: ContentPageType;
  sections: ContentPageSection[];
  isPublished: boolean;
  version: number;
  effectiveDate: string | null;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateContentPageDto {
  title?: string;
  contentType?: ContentPageType;
  sections?: ContentPageSection[];
  isPublished?: boolean;
  effectiveDate?: string | null;
}

export const contentApi = {
  listPages: async () => {
    const { data } = await apiClient.get<ApiResponse<ContentPage[]>>(
      '/admin/content/pages',
    );
    return data.data;
  },

  updatePage: async (key: ContentPageKey, patch: UpdateContentPageDto) => {
    const { data } = await apiClient.patch<ApiResponse<ContentPage>>(
      `/admin/content/pages/${key}`,
      patch,
    );
    return data.data;
  },
};
